import { OptionGroupDef } from "./readmission-f2f-types";

export const SOCIAL_HISTORY_GROUPS: OptionGroupDef[] = [
  {
    key: "smoker",
    title: "Smoker",
    options: [
      "Never smoked",
      "Ex-smoker",
      "Smokes cigarettes",
      "Chews tobacco",
      "Smokes pipe",
    ],
  },
  {
    key: "alcohol",
    title: "Alcohol",
    options: [
      "Heavy",
      "Occasionally",
      "Not provided by patient",
      "Denies drinking",
      "Last alcohol consumption",
    ],
    chooseOne: true,
  },
  {
    key: "caffeine",
    title: "Caffeine",
    options: ["Yes", "No"],
    chooseOne: true,
  },
  {
    key: "diet",
    title: "Diet",
    options: [
      "Diabetic diet",
      "Regular diet",
      "Cardiac diet",
      "Low sodium diet",
      "Low cholesterol diet",
    ],
    chooseOne: true,
  },
  {
    key: "exercise",
    title: "Exercise regimen",
    options: ["None", "Rarely", "Occasionally", "Regularly", "Daily"],
    chooseOne: true,
  },
  {
    key: "drugs",
    title: "Drugs",
    options: [
      "Does not partake in illegal drug use",
      "Cocaine",
      "Marijuana",
      "Not provided by patient",
      "Previous illicit drug use",
    ],
  },
  {
    key: "sexualHistory",
    title: "Sexual history",
    options: ["Sexually active", "Not sexually active", "Declined to answer"],
    chooseOne: true,
    withFreeText: false,
  },
  {
    key: "educationalLevel",
    title: "Educational level",
    options: [
      "Less than high school",
      "High school / GED",
      "Some college",
      "College graduate",
      "Postgraduate",
    ],
    chooseOne: true,
    withFreeText: false,
  },
  {
    key: "maritalStatus",
    title: "Marital status",
    options: ["Single", "Married", "Divorced", "Widowed", "Separated"],
    chooseOne: true,
    withFreeText: false,
  },
];

export const SOCIAL_HISTORY_EXCLUSIVE: Record<
  string,
  Record<string, string[]>
> = {
  smoker: {
    "Never smoked": [
      "Ex-smoker",
      "Smokes cigarettes",
      "Chews tobacco",
      "Smokes pipe",
    ],
  },
  alcohol: {
    "Denies drinking": ["Heavy", "Occasionally", "Not provided by patient"],
    "Not provided by patient": ["Heavy", "Occasionally", "Denies drinking"],
    Heavy: ["Occasionally"],
  },
  diet: {
    "Regular diet": [
      "Diabetic diet",
      "Cardiac diet",
      "Low sodium diet",
      "Low cholesterol diet",
    ],
  },
  drugs: {
    "Does not partake in illegal drug use": [
      "Cocaine",
      "Marijuana",
      "Previous illicit drug use",
      "Not provided by patient",
    ],
    "Not provided by patient": [
      "Cocaine",
      "Marijuana",
      "Previous illicit drug use",
      "Does not partake in illegal drug use",
    ],
  },
};

export interface SocialSubField {
  /** Title of the backend TEXT question that stores this value. */
  question: string;
  label: string;
  placeholder: string;
  /** Title of the backend BOOLEAN question for the "not stated" toggle. */
  noneQuestion?: string;
}

export interface SocialSubFieldGroup {
  option: string;
  fields: SocialSubField[];
}

/** Sub-fields shown under an option only once it is ticked, keyed by group title. */
export const SOCIAL_HISTORY_SUB_FIELDS: Record<string, SocialSubFieldGroup[]> =
  {
    Smoker: [
      {
        option: "Smokes cigarettes",
        fields: [
          {
            question: "Smoking duration",
            label: "Duration",
            placeholder: "e.g. 20 years",
            noneQuestion: "Did not state duration",
          },
          {
            question: "Smoking frequency",
            label: "Frequency",
            placeholder: "e.g. 1 pack a day",
          },
        ],
      },
    ],
    Alcohol: [
      {
        option: "Last alcohol consumption",
        fields: [
          {
            question: "Last alcohol consumption",
            label: "Date or day",
            placeholder: "e.g. 10/14/2026 or yesterday",
          },
        ],
      },
    ],
    Drugs: [
      {
        option: "Previous illicit drug use",
        fields: [
          {
            question: "Previous illicit drug use",
            label: "",
            placeholder: "What, and when",
          },
        ],
      },
    ],
  };

export const SOCIAL_SUB_NONE_VALUE = "Yes";
